export default __webpack_public_path__ + "static/media/social-x-icon.6407a59e.svg";